import React from 'react';
import { SETTINGS } from 'modules/emergencies/constants';
import QuoteText from 'modules/emergencies/components/ui/texts/QuoteText';
import BodyColumn from 'modules/emergencies/components/ui/columns/bodyColumn';
import { ReactComponent as NewIcon } from 'assets/icons/new.svg';
import { useHistory } from 'react-router-dom';
import { Tooltip } from '@ontruck/orc';

import styled from 'styled-components';
import { QuoteTooltip } from '../tooltips/QuoteTooltip';
import MessageSend from 'modules/emergencies/components/ui/icon/messageSend';
import ticketService from 'modules/emergencies/ticketService';
import usePriceNegotiationPermissions from 'modules/emergencies/permissions/usePriceNegotiationPermissions';
import PRICE_NEGOTIATION_PERMISSIONS_NAMES from 'modules/emergencies/permissions/priceNegotiationPermissionsNames';

const ButtonContainer = styled.div`
  display: flex;
  flex-grow: 1;
  gap: 4px;
  flex-direction: column;
`;
const CarrierBidsIconContainer = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;
`;
const NumberIcon = styled.div`
  border-radius: 99999px;
  height: 16px;
  min-width: 16px;
  font-size: 12px;
  background-color: #ff6400;
  color: white;
  font-weight: bold;
  text-align: center;
  padding: 0 2px;
`;
const PremiumButton = styled.button`
  outline: none;
  border: none;
  width: 100%;
  background-color: transparent;
  flex: 1 0 0;
  :disabled {
    svg path {
      fill: var(--grey500);
    }
  }
  :not(:disabled) {
    cursor: pointer;
    &:hover {
      background-color: var(--grey200);
    }
  }
`;

export const QuoteColumn = ({ ticket }) => {
  const history = useHistory();
  const canCreateQuote = usePriceNegotiationPermissions(
    PRICE_NEGOTIATION_PERMISSIONS_NAMES.QUOTE_CREATION
  );
  const isQuoteValid = ticketService.bussiness.isQuoteValid(ticket);
  const isCreateQuoteVisible =
    canCreateQuote && ticketService.bussiness.isCreateQuoteVisible(ticket);
  const isCreateQuoteEnabled = ticketService.bussiness.isCreateQuoteEnabled(ticket);
  const numberOfBids = ticketService.bussiness.numberOfBidsInOpenAuctions(ticket);
  const ticketHasOpenAuctions = ticketService.bussiness.ticketHasOpenAuctions(ticket);
  const hasQuote = !!ticket.quote;
  const isTicketCancelled = ticketService.bussiness.isTicketCancelled(ticket);

  return (
    <BodyColumn width={SETTINGS.TICKETS_TABLE_COLUMN_SIZES_IN_PX.QUOTE}>
      <CarrierBidsIconContainer>
        {!isTicketCancelled && ticketHasOpenAuctions && numberOfBids === 0 && <MessageSend />}
        {!isTicketCancelled && ticketHasOpenAuctions && numberOfBids > 0 && (
          <NumberIcon>{numberOfBids}</NumberIcon>
        )}
      </CarrierBidsIconContainer>

      <ButtonContainer>
        {isCreateQuoteVisible && (
          <PremiumButton
            onClick={() => {
              const path = `/emergencies/${ticket.id}/quote/new`;
              history.push(path);
            }}
            disabled={!isCreateQuoteEnabled}
          >
            {isCreateQuoteEnabled ? (
              <NewIcon />
            ) : (
              <Tooltip component={<QuoteTooltip ticket={ticket} />} position="bottom" skin="dark">
                <NewIcon />
              </Tooltip>
            )}
          </PremiumButton>
        )}

        {hasQuote && (
          <PremiumButton
            onClick={() => {
              const path = `/emergencies/${ticket.id}/quote/${ticket.quote.id}`;
              history.push(path);
            }}
          >
            <QuoteText isDeprecated={!isQuoteValid}>
              {ticket.quote.price.amount} {ticket.quote.price.currency}
            </QuoteText>
          </PremiumButton>
        )}
      </ButtonContainer>
    </BodyColumn>
  );
};
